{
  "about.blocks": "नियंत्रित सर्व्हर",
  "about.contact": "संपर्क:",
  "about.disclaimer": "Mastodon हे विनामूल्य, मुक्त-स्रोत सॉफ्टवेअर आहे आणि Mastodon gGmbH चे ट्रेडमार्क आहे.",
  "about.domain_blocks.no_reason_available": "कारण उपलब्ध नाही",
  "about.domain_blocks.preamble": "मास्टोडॉन तुम्हाला सामान्यत: फेडिव्हर्समधील इतर कोणत्याही सर्व्हरवरील वापरकर्त्यांवरील मजकूर पाहण्याची आणि त्यांच्याशी संवाद साधण्याची परवानगी देते. या विशिष्ट सर्व्हरवर केलेले हे अपवाद आहेत.",
  "about.domain_blocks.silenced.explanation": "जोपर्यंत तुम्ही ते स्पष्टपणे शोधत नाही किंवा अनुसरण करून निवड करत नाही तोपर्यंत तुम्हाला या सर्व्हरवरील प्रोफाइल आणि मजकूर दिसणार नाही.",
  "about.domain_blocks.silenced.title": "मर्यादित",
  "about.domain_blocks.suspended.explanation": "या सर्व्हरवरील कोणत्याही डेटावर प्रक्रिया, संचयित किंवा देवाणघेवाण केली जाणार नाही, ज्यामुळे या सर्व्हरवरील वापरकर्त्यांशी कोणताही संवाद किंवा परस्पर क्रिया अशक्य होईल.",
  "about.domain_blocks.suspended.title": "निलंबित",
  "about.not_available": "ही माहिती या सर्व्हरवर उपलब्ध करून देण्यात आलेली नाही.",
  "about.powered_by": "{mastodon} द्वारा समर्थित विकेंद्रित सोशल मीडिया",
  "about.rules": "सर्व्हर नियम",
  "account.add_or_remove_from_list": "यादीत घाला किंवा यादीतून काढून टाका",
  "account.badges.bot": "स्वयंचलित खाते",
  "account.badges.group": "गट",
  "account.block": "@{name} यांना ब्लॉक करा",
  "account.block_domain": "{domain} पासून सर्व लपवा",
  "account.block_short": "अवरोध",
  "account.blocked": "ब्लॉक केले आहे",
  "account.cancel_follow_request": "फॉलो विनंती मागे घ्या",
  "account.copy": "दुवा कॉपी करा",
  "account.direct": "खाजगीरित्या उल्लेखीत @{name}",
  "account.disable_notifications": "जेव्हा @{name} पोस्ट करतात तेव्हा मला सूचित करणे थांबवा",
  "account.edit_profile": "प्रोफाइल एडिट करा",
  "account.enable_notifications": "जेव्हा @{name} पोस्ट करते तेव्हा मला सूचित करा",
  "account.endorse": "प्रोफाइलवरील वैशिष्ट्य",
  "account.follow": "अनुयायी व्हा",
  "account.follow_back": "आपणही अनुसरण करा",
  "account.followers": "अनुयायी",
  "account.followers.empty": "ह्या वापरकर्त्याचा आतापर्यंत कोणी अनुयायी नाही.",
  "account.following": "अनुसरण",
  "account.follows.empty": "हा वापरकर्ता अजूनपर्यंत कोणाचा अनुयायी नाही.",
  "account.go_to_profile": "प्रोफाइल वर जा",
  "account.hide_reblogs": "@{name} पासून सर्व बूस्ट लपवा",
  "account.joined_short": "सामील झाले",
  "account.languages": "सदस्यता घेतलेल्या भाषा बदला",
  "account.link_verified_on": "या लिंकची मालकी {date} रोजी तपासली गेली",
  "account.locked_info": "या खात्याची गोपनीयता स्थिती लॉक वर सेट केली आहे. त्यांचे अनुसरण कोण करू शकते याचे मालक स्वतः पुनरावलोकन करतात.",
  "account.media": "दृक्‌‌श्राव्य मजकूर",
  "account.mention": "@{name} चा उल्लेख करा",
  "account.moved_to": "{name} ने सूचित केले आहे की त्यांचे नवीन खाते आता आहे:",
  "account.mute": "@{name} ला मूक कारा",
  "account.mute_short": "नि:शब्द",
  "account.muted": "मौन",
  "account.open_original_page": "मूळ पृष्ठ उघडा",
  "account.posts": "Toots",
  "account.report": "@{name} ची तक्रार करा",
  "account.requested_follow": "{name} ने आपल्याला फॉलो करण्याची रिक्वेस्ट केली आहे",
  "account.share": "@{name} चे प्रोफाइल शेअर करा",
  "account.show_reblogs": "{name}चे सर्व बुस्ट्स दाखवा",
  "account.unblock": "@{name} ला ब्लॉक करा",
  "account.unblock_domain": "उघड करा {domain}",
  "account.unblock_short": "अनब्लॉक करा",
  "account.unendorse": "प्रोफाइलवर वैशिष्ट्य देऊ नका",
  "account.unfollow": "अनुयायी असणे थांबवा",
  "account.unmute": "@{name} अनम्यूट करा",
  "account.unmute_short": "अनम्यूट करा",
  "account_note.placeholder": "Click to add a note",
  "admin.dashboard.daily_retention": "साइन अप केल्यानंतर दिवसा वापरकर्ता धारणा दर",
  "admin.dashboard.monthly_retention": "साइन अप केल्यानंतर महिन्यानुसार वापरकर्ता धारणा दर",
  "admin.dashboard.retention.average": "सरासरी",
  "admin.dashboard.retention.cohort": "साइन-अप महिना",
  "admin.dashboard.retention.cohort_size": "नवीन वापरकर्ता",
  "alert.rate_limited.message": "कृपया {retry_time, time, medium} नंतर पुन्हा प्रयत्न करा.",
  "alert.rate_limited.title": "दर मर्यादित",
  "alert.unexpected.message": "एक अनपेक्षित त्रुटी आली.",
  "alert.unexpected.title": "अरेरे!",
  "announcement.announcement": "घोषणा",
  "bundle_column_error.retry": "पुन्हा प्रयत्न करा",
  "bundle_modal_error.close": "बंद करा",
  "bundle_modal_error.retry": "पुन्हा प्रयत्न करा",
  "column.blocks": "ब्लॉक केलेले खातेधारक",
  "column.domain_blocks": "गुप्त डोमेन्स",
  "column.follow_requests": "अनुचरण विनंत्या",
  "column.home": "मुख्यपृष्ठ",
  "column.lists": "याद्या",
  "column.mutes": "नि: शब्द खातेधारक",
  "column.notifications": "सूचना",
  "column.pins": "Pinned toot",
  "column_back_button.label": "मागे",
  "column_header.hide_settings": "सेटिंग लपवा",
  "column_header.moveLeft_settings": "स्तंभ डावीकडे सरकवा",
  "column_header.moveRight_settings": "स्तंभ उजवीकडे सरकवा",
  "column_header.pin": "टाचण",
  "column_header.show_settings": "सेटिंग्स दाखवा",
  "column_header.unpin": "अनपिन करा",
  "community.column_settings.media_only": "केवळ मीडिया",
  "compose_form.direct_message_warning_learn_more": "अधिक जाणून घ्या",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.placeholder": "आपल्या मनात काय आहे?",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "confirmations.delete.confirm": "हटवा",
  "confirmations.delete.message": "हे स्टेटस तुम्हाला नक्की हटवायचंय?",
  "confirmations.delete_list.confirm": "हटवा",
  "confirmations.delete_list.message": "ही यादी तुम्हाला नक्की कायमची हटवायचीय?",
  "confirmations.logout.message": "तुमची खात्री आहे की तुम्ही लॉग आउट करू इच्छिता?",
  "confirmations.mute.confirm": "आवाज बंद करा",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "empty_column.account_timeline": "No toots here!",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.domain_blocks": "There are no hidden domains yet.",
  "empty_column.home": "Your home timeline is empty! Follow more people to fill it up. {suggestions}",
  "empty_column.list": "There is nothing in this list yet. When members of this list post new statuses, they will appear here.",
  "hashtag.column_settings.tag_mode.all": "यातील सर्व",
  "hashtag.column_settings.tag_mode.any": "यापैकी कोणतेही",
  "hashtag.column_settings.tag_mode.none": "यापैकी एकही नाही",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.follow": "हॅशटॅग फॉलो करा",
  "hashtag.unfollow": "हॅशटॅग अनफॉलो करा",
  "home.column_settings.show_reblogs": "बूस्ट दाखवा",
  "home.column_settings.show_replies": "उत्तरे दाखवा",
  "home.hide_announcements": "घोषणा लपवा",
  "home.show_announcements": "घोषणा दाखवा",
  "interaction_modal.on_another_server": "वेगळ्या सर्व्हरवर",
  "interaction_modal.on_this_server": "या सर्व्हरवर",
  "intervals.full.days": "{number, plural, one {# day} other {# days}}",
  "intervals.full.hours": "{number, plural, one {# hour} other {# hours}}",
  "intervals.full.minutes": "{number, plural, one {# minute} other {# minutes}}",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "to boost",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "वर्णन",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.hotkey": "हॉटकी",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "to open media",
  "keyboard_shortcuts.pinned": "to open pinned toots list",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "to show/hide media",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "बंद करा",
  "lightbox.next": "पुढे",
  "lightbox.previous": "मागील",
  "limited_account_hint.action": "तरीही प्रोफाइल दाखवा",
  "limited_account_hint.title": "हे प्रोफाइल {domain} च्या नियंत्रकांनी लपवले आहे.",
  "lists.delete": "सूची हटवा",
  "lists.edit": "सूची संपादित करा",
  "lists.replies_policy.followed": "कोणताही फॉलो केलेला वापरकर्ता",
  "lists.replies_policy.list": "यादीतील सदस्य",
  "lists.replies_policy.none": "कोणीच नाही",
  "load_pending": "{count, plural, one {# new item} other {# new items}}",
  "navigation_bar.domain_blocks": "Hidden domains",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.reblog": "{name} boosted your status",
  "notifications.column_settings.push": "सूचना",
  "notifications.column_settings.reblog": "बूस्ट:",
  "notifications.column_settings.show": "स्तंभात दाखवा",
  "notifications.column_settings.sound": "ध्वनी प्ले करा",
  "notifications.column_settings.status": "New toots:",
  "notifications.column_settings.unread_notifications.category": "अपठित अधिसूचना",
  "notifications.column_settings.unread_notifications.highlight": "न वाचलेल्या सूचना हायलाइट करा",
  "notifications.column_settings.update": "संपादने:",
  "notifications.filter.all": "सर्व",
  "notifications.filter.boosts": "बूस्ट",
  "notifications.filter.follows": "अनुयायी आहे",
  "notifications.filter.mentions": "उल्लेख केलेले",
  "notifications.filter.polls": "मतदान परिणाम",
  "notifications.filter.statuses": "तुम्ही फॉलो करत असलेल्या लोकांकडून अपडेट",
  "privacy.change": "Adjust status privacy",
  "report.placeholder": "Type or paste additional comments",
  "report.submit": "Submit report",
  "report.target": "Report {target}",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "search_results.statuses": "Toots",
  "sign_in_banner.sign_in": "Sign in",
  "status.admin_status": "Open this status in the moderation interface",
  "status.copy": "Copy link to status",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.open": "Expand this status",
  "status.reblogs.empty": "No one has boosted this toot yet. When someone does, they will show up here.",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "upload_progress.label": "Uploading…"
}
